import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetActiveMissions} from '../../../../backend-services/Coins/utils/useGetActiveMissions';
import {NewsletterMissionBannerView} from './NewsletterMissionBannerView';

export const NewsletterMissionBanner: React.FC = () => {
  return (
    <DataFetcher
      request={useGetActiveMissions()}
      Error={null}
      View={NewsletterMissionBannerView}
      Loading={() => null}
    />
  );
};
